import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-expiry',
  templateUrl: './expiry.component.html',
  styleUrls: ['./expiry.component.scss']
})
export class ExpiryComponent implements OnInit {

  public expiryTimes = [
    { name: 'min', type: 'minute', value: 1 },
    { name: 'mins', type: 'minute', value: 10 },
    { name: 'hour', type: 'hour', value: 1 },
    { name: 'day', type: 'day', value: 1 },
    { name: 'days', type: 'day', value: 3 },
    { name: 'days', type: 'day', value: 7 },
    { name: 'days', type: 'day', value: 30 },
    { name: 'months', type: 'month', value: 3 },
    { name: 'months', type: 'month', value: 6 },
    { name: 'year', type: 'year', value: 1 },
    { name: 'years', type: 'year', value: 2 },
    { name: 'years', type: 'year', value: 3 },
  ];

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() { }

  async setExpiryTime(expiry) {
    if (expiry === 'custom') {
      await this.modalCtrl.dismiss({ type: 'custom' });
    }

    await this.modalCtrl.dismiss(expiry);
  }

  async goBack() {
    await this.modalCtrl.dismiss();
  }

}
